function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "steper_theme");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.73
}, React.createElement("g", {
  id: "steper_theme",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M10.4920844,2.49090909 C10.7725989,2.49090909 11,2.26298182 11,1.98181818 L11,0.509090909 C11,0.227927273 10.7725989,0 10.4920844,0 L1.05791557,0 C0.777401055,0 0.55,0.227927273 0.55,0.509090909 L0.55,7.0864 C0.55,7.93134545 1.23612137,8.61861818 2.07926121,8.61861818 L3.40695251,8.61861818 C3.68993404,8.61861818 3.92023747,8.84916364 3.92023747,9.13265455 L3.92023747,14.1418182 C3.92038259,15.1664 4.75234828,16 5.775,16 C6.79765172,16 7.62961741,15.1664 7.62961741,14.1418182 L7.62961741,9.13265455 C7.62961741,8.84916364 7.85992084,8.61861818 8.14290237,8.61861818 L9.47059367,8.61861818 C10.3138786,8.61861818 10.9998549,7.9312 10.9998549,7.0864 L10.9998549,4.87272727 C10.9998549,4.59156364 10.7724538,4.36363636 10.4919393,4.36363636 L2.94431398,4.36363636 C2.66379947,4.36363636 2.43639842,4.59156364 2.43639842,4.87272727 C2.43639842,5.15389091 2.66379947,5.38181818 2.94431398,5.38181818 L9.98402375,5.38181818 L9.98402375,7.0864 C9.98402375,7.36989091 9.75372032,7.60043636 9.47059367,7.60043636 L8.14290237,7.60043636 C7.29961741,7.60043636 6.61378628,8.28785455 6.61378628,9.13265455 L6.61378628,14.1418182 C6.61378628,14.6050909 6.2374934,14.9818182 5.775,14.9818182 C5.3125066,14.9818182 4.93621372,14.6049455 4.93621372,14.1418182 L4.93621372,9.13265455 C4.93621372,8.28770909 4.25023747,7.60043636 3.40709763,7.60043636 L2.07940633,7.60043636 C1.79627968,7.60043636 1.56597625,7.36989091 1.56597625,7.0864 L1.56597625,1.01818182 L9.98431398,1.01818182 L9.98431398,1.98181818 C9.98416887,2.26298182 10.2115699,2.49090909 10.4920844,2.49090909 Z",
  id: "Path"
})));

var SvgPaint = function SvgPaint(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "11px",
    height: "16px",
    viewBox: "0 0 11 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paint.942bbf43.svg";
export { ForwardRef as ReactComponent };